import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddordersComponent } from '../add-orders/add-orders.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { debounceTime, Observable, Subject } from 'rxjs';
import { ordersService } from '../../services/orders.service';
import { CreateTmsOrderComponent } from '../tms-order/create-tms-order/create-tms-order.component';
import { ViewBiddingComponent } from '../view-bidding/view-bidding.component';
import { VendorBillPopupComponent } from '../vendor-bill-popup/vendor-bill-popup.component';
import { CustomerBillPopupComponent } from '../customer-bill-popup/customer-bill-popup.component';
import { ColumnPreferenceService } from 'src/app/shared/services/column-preference.service';

const ORDER_STATUS_MAP: Record<string, StatusMeta> = {
  CREATED: { label: 'Created', badgeClass: 'badge-yellow' },
  // PRICING_PENDING: { label: 'Quote Pending on Procurement', badgeClass: 'badge-yellow' },
  QUOTE_PENDING: { label: 'Quote Pending on Procurement', badgeClass: 'badge-yellow' },
  DRAFT: { label: 'Draft', badgeClass: 'badge-grey' },
  IN_ACTIVE: { label: 'Inactive', badgeClass: 'badge-grey' },
  QUOTE_SHARED: { label: 'Quote Shared', badgeClass: 'badge-purple-outline' },
  HEAD_PENDING: { label: 'Pending on Head', badgeClass: 'badge-yellow' },
  HEAD_APPROVED: { label: 'Approved', badgeClass: 'badge-green' },
  HEAD_REJECTED: { label: 'Rejected', badgeClass: 'badge-red' },
  REJECTED: { label: 'Rejected', badgeClass: 'badge-red' },
  CANCELLED: { label: 'Cancelled', badgeClass: 'badge-red' },
  ORDER_CONFIRMED: { label: 'Confirmed', badgeClass: 'badge-green' },
};

interface StatusMeta {
  label: string;
  badgeClass: string;
}

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class ordersComponent {
  theme = 'dark'
  pageSize = 50; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC'
  tableName = 'orderTable'
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData: any[] = [];
  editContation: boolean = false;
  first: number = 0;
  // filters= [];
  filters: { key: string; value: any }[] = [];
  userType: any;
  
  // ── Submit Rate dialog state ──
  showSubmitRateDialog = false;
  submitRateStep: 'confirm' | 'form' = 'confirm';
  inviteVendors = false;
  currentOrderForRate: any = null;
  rateForm!: FormGroup;
 
  vendorList: any[] = [];
 
  showBiddingDialog = false;
  currentBiddingOrder: any = null;
  biddingForm!: FormGroup;
  biddingLoading = false;
  selectedBiddingItem: any = null;
  showBiddingConfirmDialog = false;
  pendingBiddingStatus: string | null = null;

  columns = [
    // { showColumn: false, sortingColumn: '', key: 'orderNumber', header: 'Order Id', sortable: false, type: 'text', viewDialog: true, viewHistory: true, componentName: 'orders' },
    // {showColumn: true, sortingColumn: '',  key: 'orderCode', header: ' Order Code ', sortable: false, type: 'text', viewDialog: false },
    { showColumn: true, sortingColumn: '', key: 'orderNumber', header: 'Order No', sortable: false, viewDialog: true, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'warehouseCode', header: 'Warehouse', sortable: false, type: 'text', viewDialog: false },
    // { showColumn: true, sortingColumn: '', key: 'customerWarehouseId', header: 'Warehouse', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: '',  key: 'vendors', header: 'Vendor', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: '',  key: 'headCountNeeded', header: 'Head Count', sortable: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'status', header: 'LR Number', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'customerName', header: 'Customer', sortable: false, type: 'text', viewDialog: false },
    // { showColumn: true, sortingColumn: '', key: 'fromDate', header: 'Date of Placement', sortable: false, type: 'invoicedate' },
    // { showColumn: true, sortingColumn: '', key: 'jobLineItems', header: 'Route Details', sortable: false, type: 'RouteDetails' },
    { showColumn: true, sortingColumn: '', key: 'route', header: 'Route', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'orderType', header: 'Type', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'contactAlternateMobile', header: 'Contact Alternate Number', sortable: false, viewDialog: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: 'contactEmail', header: 'KAM', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'fromDate', header: 'Order From Date', sortable: false, type: 'invoicedate' },
    { showColumn: true, sortingColumn: '', key: 'remarks', header: 'Price Status', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'districtName', header: 'Location', sortable: false, viewDialog: false, type: 'text' },
    // { showColumn: true, sortingColumn: '', key: 'stateName', header: 'State', sortable: false, viewDialog: false, type: 'text' },
    // {showColumn: true, sortingColumn: 'createdAt',  key: 'createdAt', header: 'Created At', sortable: true, type: 'date' },
    // {showColumn: true, sortingColumn: '',  key: 'createdByName', header: 'Created By', sortable: false, type: 'text' },
    // {showColumn: true, sortingColumn: 'updatedAt',  key: 'updatedAt', header: 'Updated At', sortable: true, type: 'date' },
    // {showColumn: true, sortingColumn: '',  key: 'updatedByName', header: 'Updated By', sortable: false, type: 'text' },
    { showColumn: true, sortingColumn: '', key: '', header: 'Action', sortable: false, type: 'action', viewDialog: true, viewHistory: true, componentName: 'orders' },

  ];

  columnsToExport: string[] = ['financialYearId', 'budgetDate', 'budgetType', 'reference', 'accountName', 'warehouseName', 'approvedBudget', 'expense', 'createdAt', 'createdByName', 'updatedAt', 'updatedByName', 'budgetProof', 'remarks'];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount: any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any = [];
  user_details: any;
  activeQuickFilter: string | null = null;
  private getListTrigger$ = new Subject<void>();
  roleNames: string[] = [];
  roleName:any;
  quickFilters: any[] = []; // populated per-role in ngOnInit via setupQuickFilters()

  showTransactionDialog = false;
  transactionLoading = false;
  historyTransactions: any[] = [];
  selectedBidForHistory: any = null;
  alreadyInvitedVendorIds: any[] = [];
  private quickFilterConfig: { [role: string]: any[] } = {
  
    ROLE_KAM: [
      { label: 'Pending Action',  value: 'PENDING_ACTION',   color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'STATUS', value: 'QUOTE_SHARED,HEAD_APPROVED' }] },
        { label: 'Pending on Procurement', value: 'PENDING_ON_PROC',  color: '#f59e0b', count: 0,
          filters: [{ key: 'STATUS', value: 'CREATED,QUOTE_PENDING' }] },
        { label: 'Draft Order', value: 'DRAFT_ORDER',  color: '#f59e0b', count: 0,
          filters: [{ key: 'STATUS', value: 'DRAFT' }] },
        { label: 'Pending on Head', value: 'PENDING_ON_HEAD',  color: '#f59e0b', count: 0,
          filters: [{ key: 'STATUS', value: 'HEAD_PENDING' }] },
        { label: 'Others',          value: 'OTHERS',           color: '#9ca3af', count: 0,
          filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }] },
        {
          label: 'All',
          value: 'ALL',
          color: '#2563eb',
          count: 0,
          filters: [
            {
              key: 'STATUS',
              value: 'QUOTE_SHARED,HEAD_APPROVED,CREATED,QUOTE_PENDING,HEAD_PENDING,ORDER_CONFIRMED,DRAFT'
            }
          ]
        },
    ],
  
    ROLE_PROCUREMENT: [
      { label: 'Quote Requested',     value: 'QUOTE_REQUESTED',     color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'BIDDING_ENABLE', value: '0' }, { key: 'STATUS', value: 'CREATED,QUOTE_PENDING' }] },
      { label: 'Pending Trips',       value: 'PENDING_TRIPS',       color: '#ef4444', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }] },
      // { label: 'Pending LHC',       value: 'PENDING_LHC',       color: '#ef4444', count: 0,
      //   filters: [{ key: 'STATUS', value: 'PENDING_LHC' }] },
      { label: 'Pending on KAM',      value: 'PENDING_ON_KAM',      color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'QUOTE_SHARED,HEAD_APPROVED' }] },
      { label: 'Pending on Head',     value: 'PENDING_ON_HEAD',     color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'HEAD_PENDING' }] },
      { label: 'Bidding in Progress', value: 'BIDDING_IN_PROGRESS', color: '#3b82f6', count: 0,
        filters: [{ key: 'BIDDING_ENABLE', value: '1' }, { key: 'STATUS', value: 'CREATED,QUOTE_PENDING' }] },
      { label: 'Others',              value: 'OTHERS',              color: '#9ca3af', count: 0,
        filters: [{ key: 'TRIP_STATUS', value: 'TRIP_ENDED' }] },
      {
        label: 'All',
        value: 'ALL',
        color: '#2563eb',
        count: 0,
        filters: [
          {
            key: 'STATUS',
            value: 'CREATED,QUOTE_PENDING,QUOTE_SHARED,HEAD_APPROVED,HEAD_PENDING,ORDER_CONFIRMED'
          }
        ]
      },
    ],
  
    ROLE_OPERATION: [
      { label: 'Quote Pending', value: 'QUOTE_PENDING', color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }, { key: 'TRIP_STATUS', value: 'TRIP_GENERATED' }] },
      { label: 'Hard POD Pending', value: 'HARD_POD', color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'HARD_POD_STATUS', value: 'PENDING' }] },
      { label: 'Hard POD Received', value: 'HARD_RECEIVED_POD', color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'HARD_POD_STATUS', value: 'RECEIVED' }] },  
      { label: 'Trip in Progress', value: 'TRIP_IN_PROGRESS', color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }, { key: 'TRIP_STATUS', value: 'TRIP_INPROGRESS' }] },
      // { label: 'Others',           value: 'OTHERS',           color: '#9ca3af', count: 0,
      //   filters: [] },
      {
        label: 'All',
        value: 'ALL',
        color: '#2563eb',
        count: 0,
        filters: [
          {
            key: 'STATUS',
            value: 'ORDER_CONFIRMED'
          }
        ]
      },
    ],
  
    ROLE_PROCUREMENT_HEAD: [
      { label: 'Quote Requested', value: 'QUOTE_REQUESTED', color: '#f59e0b', count: 0,
        filters: [{ key: 'STATUS', value: 'HEAD_PENDING' }] },
      { label: 'Pending Trips',       value: 'PENDING_TRIPS',       color: '#ef4444', count: 0,
        filters: [{ key: 'STATUS', value: 'ORDER_CONFIRMED' }] }, 
      {
        label: 'All',
        value: 'ALL',
        color: '#2563eb',
        count: 0,
        filters: [
          { key: 'STATUS', value: 'CREATED,QUOTE_PENDING,QUOTE_SHARED,HEAD_APPROVED,HEAD_PENDING,ORDER_CONFIRMED' },
        ]
      },
    ],
    // ROLE_BILLING_USER: [
    //   { label: 'Ready for vendor billing', value: 'READY_FOR_VENDOR_BILLING', color: 'var(--background-primary-color)', count: 0,
    //     filters: [{ key: 'READY_FOR_VENDOR_BILL', value: 1}] },
    //   { label: 'Ready for cutomer billing', value: 'READY_FOR_CUSTOMER_BILLING', color: '#9ca3af', count: 0,
    //     filters: [{ key: 'READY_FOR_CUSTOMER_BILL', value: 1 }] },
    //   {
    //     label: 'All',
    //     value: 'ALL',
    //     color: '#2563eb',
    //     count: 0,
    //     filters: [
    //       { key: 'READY_FOR_VENDOR_BILL', value: 1 },
    //       { key: 'READY_FOR_CUSTOMER_BILL', value: 1 }
    //     ]
    //   },
    // ],
    ROLE_VENDOR_BILLING_USER: [
      { label: 'Ready for vendor billing', value: 'READY_FOR_VENDOR_BILLING', color: 'var(--background-primary-color)', count: 0,
        filters: [{ key: 'READY_FOR_VENDOR_BILL', value: 1}] },
    ],
    ROLE_CUSTOMER_BILLING_USER: [
      { label: 'Ready for cutomer billing', value: 'READY_FOR_CUSTOMER_BILLING', color: '#9ca3af', count: 0,
        filters: [{ key: 'READY_FOR_CUSTOMER_BILL', value: 1 }] },
    ],
  };
  summaryStatusConfig: { [key: string]: string[] } = {
    ROLE_KAM: [
      'TRIP_STATUS'
    ],
  
    ROLE_PROCUREMENT: [
      'TRIP_STATUS',
      'LHC_STATUS'
    ],

    ROLE_PROCUREMENT_HEAD: [
      'TRIP_STATUS',
      'LHC_STATUS'
    ],
  
    ROLE_OPERATION: [
      'TRIP_STATUS',
      'SOFT_POD_STATUS',
      'HARD_POD_STATUS'
    ],
  
    ROLE_CLAIM_USER: [
      'TRIP_STATUS',
      'CLAIM_STATUS'
    ],
  
    // ROLE_BILLING_USER: [
    //   'TRIP_STATUS',
    //   'HARD_POD_STATUS',
    //   'CLAIM_STATUS',
    //   'VENDOR_BILLING_STATUS'
    // ],
    ROLE_CUSTOMER_BILLING_USER: [
      'TRIP_STATUS',
      'HARD_POD_STATUS',
      'CLAIM_STATUS',
      'CUSTOMER_BILLING_STATUS'
    ],
    ROLE_VENDOR_BILLING_USER: [
      'TRIP_STATUS',
      'HARD_POD_STATUS',
      'CLAIM_STATUS',
      'VENDOR_BILLING_STATUS'
    ],
  
    // ROLE_BILLING_SUPERVISOR: [
    //   'TRIP_STATUS',
    //   'CUSTOMER_BILLING_STATUS',
    //   'SOFT_POD_STATUS',
    //   'HARD_POD_STATUS',
    //   'CLAIM_STATUS',
    //   'VENDOR_BILLING_STATUS'
    // ]
    ROLE_CUSTOMER_BILLING_SUPERVISOR: [
      'TRIP_STATUS',
      'CUSTOMER_BILLING_STATUS',
      'SOFT_POD_STATUS',
      'HARD_POD_STATUS',
      'CLAIM_STATUS'
    ],
    ROLE_VENDOR_BILLING_SUPERVISOR: [
      'TRIP_STATUS',
      'SOFT_POD_STATUS',
      'HARD_POD_STATUS',
      'CLAIM_STATUS',
      'VENDOR_BILLING_STATUS'
    ]
  };
  filterData: any;
  readonly MODULE_NAME = 'Orders';
  private roleColumnVisibility: Record<string, () => boolean> = {
    status:            () => true,
    lrNumber:          () => this.notRole('ROLE_VENDOR'),
    customerName:      () => this.notRole('ROLE_VENDOR'),
    vendorName:        () => this.hasRole('ROLE_VENDOR_BILLING_USER'),
    accountName:       () => this.hasRole('ROLE_VENDOR'),
    route:             () => true,
    vehicleRequiredAt: () => true,
    orderType:         () => this.notRole('ROLE_VENDOR'),
    assignedKam:       () => this.notRole('ROLE_VENDOR'),
    procurementPrice:  () => this.hasRole('ROLE_VENDOR'),
    bidAmount:         () => this.hasRole('ROLE_VENDOR'),
  };

  get allowedColumnKeys(): string[] {
    return Object.keys(this.roleColumnVisibility)
      .filter(key => this.roleColumnVisibility[key]());
  }

  constructor(private ordersService: ordersService,
    private primengConfig: PrimeNGConfig, private fb: FormBuilder, private tabService: TabService,
    public dialogService: DialogService, private messageService: MessageService, private router: Router, public accessControlService: AccessControlService,
    private columnPreferenceService: ColumnPreferenceService) {
    
      this.getListTrigger$.pipe(debounceTime(0)).subscribe(() => this.fetchList());
      
      this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.roleNames = (this.user_details?.userRoles || []).map((r: any) => r.name);
    this.roleName = this.user_details.roleName;

    this.userType = this.user_details?.userType;
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null)
  });

  ngOnInit(): void {
    this.buildRateForm();
    this.buildBiddingForm();
    // this.getList()
    this.setupQuickFilters();
  }

  hasRole(...roles: string[]): boolean {
    return roles.some(r => this.roleNames.includes(r));
  }
  
  /** True if the user has NONE of the given roles */
  notRole(...roles: string[]): boolean {
    return !this.hasRole(...roles);
  }

  setupQuickFilters(): void {
    const merged: any[] = [];
    const seen = new Set<string>();

    this.roleNames.forEach(role => {
      (this.quickFilterConfig[role] || []).forEach(qf => {
        if (!seen.has(qf.value)) {
          seen.add(qf.value);
          merged.push(qf);
        }
      });
    });

    this.quickFilters = merged;

    if (this.hasRole('ROLE_VENDOR') || this.quickFilters.length === 0) {
      this.getList();
      return;
    }

    this.onQuickFilter(this.quickFilters[0]);
  }
  
  /** Every key any quick filter for the current role can set — used to clear
   *  the previous chip's keys before applying a new one, since chips can set
   *  different keys (STATUS vs BIDDING_ENABLE vs TRIP_STATUS). */
  private get quickFilterKeys(): string[] {
    const keys = new Set<string>();
    this.quickFilters.forEach(qf => (qf.filters || []).forEach((f: any) => keys.add(f.key)));
    return Array.from(keys);
  }
  
  // ─────────────────────────────────────────────
  // Submit Rate — inline dialog logic
  // ─────────────────────────────────────────────
 
  isAllSelected(): boolean {
    const selected = this.rateForm.get('vendors')?.value || [];
    return selected.length === this.vendorList.length;
  }
  
  isSomeSelected(): boolean {
    const selected = this.rateForm.get('vendors')?.value || [];
    return selected.length > 0 && selected.length < this.vendorList.length;
  }
  
  toggleSelectAll(): void {
    const allIds = this.vendorList.map(v => v.id);
    const selected = this.rateForm.get('vendors')?.value || [];
  
    if (selected.length === this.vendorList.length) {
      // all selected → deselect all
      this.rateForm.get('vendors')?.setValue([]);
    } else {
      // none or some selected → select all
      this.rateForm.get('vendors')?.setValue(allIds);
    }
  }

  getLrNumbers(tripLrInfo: any[]): string {
    if (!tripLrInfo?.length) {
      return '--';
    }
  
    return tripLrInfo
      .map(item => item?.lrNumber)
      .filter(Boolean)
      .join(', ');
  }

  getVendorList(){
    this.ordersService.getVendorInfo([],0,100000).subscribe((res:any)=>{
      this.vendorList = res?.responseObject?.content
    })
  }

  loadExistingVendorInvites(orderId: any): void {
    const filters = [{ key: 'ORDER_ID', value: orderId.toString() }];
    this.ordersService.getVendorOrders(filters, 0, 10000, 'id', 'DESC').subscribe({
      next: (res: any) => {
        const bids = res?.responseObject?.content || [];
        this.alreadyInvitedVendorIds = Array.from(
          new Set(bids.map((b: any) => b.vendorId).filter((v: any) => v != null))
        );
      },
      error: () => {
        this.alreadyInvitedVendorIds = [];
      }
    });
  }

  buildRateForm(): void {
    this.rateForm = this.fb.group({
      rate:    [null, [Validators.required, Validators.min(1)]],
      vendors: [null, Validators.required]
    });
  }
 
  openSubmitRate(item: any): void {
    this.getVendorList()
    this.loadExistingVendorInvites(item.id); 
    this.currentOrderForRate = item;
    this.submitRateStep = 'confirm';
    this.inviteVendors = false;
    this.rateForm.reset();
    if(item?.profitAdjustedCustomerAmount){
      this.rateForm.controls['rate'].setValue(item?.profitAdjustedCustomerAmount.toString())
    }
    this.showSubmitRateDialog = true;
  }
 
  onYesInvite(): void {
    this.inviteVendors = true;
    this.submitRateStep = 'form';
    this.rateForm.get('vendors')?.setValue([...this.alreadyInvitedVendorIds]); 
  }
 
  onNoJustSubmit(): void {
    this.inviteVendors = false;
    this.submitRateStep = 'form';
  }
 
  onRateBack(): void {
    this.submitRateStep = 'confirm';
    this.rateForm.reset();
  }
 
  isRateInvalid(field: string): boolean {
    const ctrl = this.rateForm.get(field);
    return !!ctrl && ctrl.touched && ctrl.invalid;
  }
 
  onSubmitRate(): void {
  if (this.rateForm.invalid) {
    this.rateForm.markAllAsTouched();
    return;
  }

  const formValue = this.rateForm.value;

  let payload: any;

  if (this.inviteVendors) {
    const newVendorIds = (formValue.vendors || [])
      .filter((id: any) => !this.alreadyInvitedVendorIds.includes(id));

    if (!newVendorIds.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select at least one new vendor to invite'
      });
      return;
    }

    payload = {
      id:                       this.currentOrderForRate?.id,
      procurementProvidedAmount: formValue.rate,
      biddingEnable:            1,
      biddingStatus:            'PendingOnVendor',
      vendorIds:                newVendorIds
    };
  } else {
    payload = {
      id:                       this.currentOrderForRate?.id,
      procurementProvidedAmount: formValue.rate,
      status:                   'QUOTE_SHARED',
      vendorId:                 formValue.vendors
    };
  }

  console.log('Submit Rate Payload:', payload);

  this.ordersService.createUpdateOrder(payload).subscribe({
    next: (res: any) => {
      this.showSubmitRateDialog = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res?.responseMessage || 'Rate submitted successfully'
      });
      this.getList();
    },
    error: (err: any) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.responseMessage || 'Something went wrong'
      });
    }
  });
}
 
  closeSubmitRateDialog(): void {
    this.showSubmitRateDialog = false;
  }

  getWarehouseDetails(pageIndex: number, pageSize: number, filter: any) {
    // const warehouseFilter = this.setFilter();
    this.warehouseData = []
    this.totalCount = 0
    // this.warehouseService.getWarehouseList(pageIndex, pageSize, filter).subscribe((res: any) => {
    //   this.warehouseData = res?.responseObject?.content;
    //   this.totalCount = res?.responseObject?.totalElements;
    // })
  }

  
  reloadEvent(event:any){
    console.log(event);
    this.getList()
  }

  getList(): void {
    this.getListTrigger$.next();
  }
  
  private fetchList() {
    let postData: any[] = [];
    let vendorIds: string[] = [];
    let accountIds: any;
  
    if (this.user_details?.vendorMapping?.length > 0) {
      vendorIds = this.user_details.vendorMapping.map((el: any) => el.vendorId || el.id);
    }
    if (this.user_details?.accountMapping?.length > 0) {
      accountIds = this.user_details.accountMapping.map((el: any) => el.accountId || el.id);
    }
  
    // ROLE_VENDOR — use bidding service with VENDOR_ID_IN filter
    if (this.hasRole('ROLE_VENDOR')) {
      const vendorFilter = {
        key: 'VENDOR_ID_IN',
        value: vendorIds.join(',')
      };
    
      const finalFilters = [
        ...(this.filterData || []).filter(
          (filter: any) => filter?.key !== 'VENDOR_ID_IN'
        ),
        vendorFilter
      ];
    
      this.tableLists = [];
    
      this.ordersService
        .getVendorOrders(
          finalFilters,
          this.pageNumber,
          this.pageSize,
          this.sortingCol,
          this.direction
        )
        .subscribe((data: any) => {
          if (data) {
            this.tableLists = data?.responseObject?.content || [];
            this.tableLists.forEach((el: any) => {
              if (el?.source && el?.destination) {
                el.route = el?.source + ' - ' + el?.destination;
              }
            });
            this.totalCount = data?.responseObject?.totalElements;
            this.tableLists = this.tableLists.filter((el: any) => el.status !== 'Draft');
            this.selectedData = [];
          }
        }, err => {
          this.totalCount = 0;
          this.tableLists = [];
        });
  
      return;
    }
  
    // ── Rebuild filters fresh every time: strip whatever quick-filter keys
    //    might already be sitting in this.filters, then reapply the CURRENTLY
    //    active chip's key/values. This means no matter who called getList()
    //    (init, search, reset, chip click), the active quick filter can never
    //    silently disappear. ──
    this.filters = this.buildFilters();
  
    this.tableLists = []
    this.ordersService
      .getFtlOrders(this.filters, this.pageNumber, this.pageSize, this.sortingCol, this.direction)
      .subscribe((data: any) => {
        if (data) {
          this.tableLists = data?.responseObject?.content;
          this.tableLists.forEach((el: any) => {
            if (el?.source && el?.destination) {
              el.route = el?.source + ' - ' + el?.destination;
            }
          });
          this.totalCount = data?.responseObject?.totalElements;
          this.tableLists = this.tableLists.filter((el: any) => el.status !== 'Draft');
          this.selectedData = []
        }
      }, err => {
        this.totalCount = 0
        this.tableLists = []
      });
  }

  private buildFilters(): { key: string; value: any }[] {
    let base = (this.filters || []).filter((f: any) => !this.quickFilterKeys.includes(f.key));
  
    if (this.activeQuickFilter) {
      const active = this.quickFilters.find(qf => qf.value === this.activeQuickFilter);
      if (active) {
        base = [...base, ...(active.filters || [])];
      }
    }
  
    return base.filter(
      (item: any) =>
        (item.value && item.value.toString().trim() !== '') ||
        (item.dateValue && item.dateValue.toString().trim() !== '') ||
        (item.dateTimeValue && item.dateTimeValue.toString().trim() !== '')  
    );
  }

  getListExportApi = (params: any): Observable<any> => {
    const {
      filters = {}, pageNumber = 0, pageSize = 250, sortingCol = 'id',
      direction = 'DESC'
    } = params;

    return this.ordersService.getOrders(
      filters, pageNumber, pageSize, sortingCol, direction
    );
  };

  onFilterChange(event: any) {
    if (event) {
      this.filterData = event || [];
      this.pageNumber = 0;
      this.filters = event
      this.getList()
    }
  }

  onResetFilters() {
    this.filters = []
    this.filterData = []
    this.getList()
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex
    this.pageSize = event.pageSize
    this.currentPage = event.pageIndex
    this.first = event.pageIndex * event.pageSize
    this.getList()
  }

  onSortChange(event: { columnKey: string, sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey
    this.direction = event.sortOrder
    this.getList()
  }

  sortColumn(columnKey: string, sortOrder: 'ASC' | 'DESC') {
    this.onSortChange({ columnKey, sortOrder });
  }

  editOrderRow(item: any) {
    this.selectedData = [item];
    this.editEvent();
  }

  viewOrderDetails(id: any) {
    // open your view dialog / navigate to order detail
  }

  receiveHardPod(){
    const payload = this.selectedRows.map((row: any) => ({
      orderId: row.id,
      tripId: row?.tripLrInfo[0]?.tripId,
      accountId: row?.accountId,
      customerId: row?.customerId,
      vendorId: row?.vendorId,
      podType:    'Hard',
      status:     'RECEIVED',
    }));
    this.ordersService.submitMultiPod(payload).subscribe((res=>{
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Hard POD submit successfully'
      });
      this.getList();
    }))
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(localStorage.getItem('columnToExport') || '{}');

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;

    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;

    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  private hasSameValue(field: string): boolean {
    if (!this.selectedData?.length) {
      return false;
    }
  
    const value = this.selectedData[0]?.[field];
  
    return this.selectedData.every(item => item?.[field] === value);
  }
  
  canCreateVendorBill(): boolean {
    return this.hasSameValue('vendorName');
  }
  
  canCreateCustomerBill(): boolean {
    return this.hasSameValue('customerName');
  }

  createVendorBill(): void {
    if (!this.selectedData?.length) {
      return;
    }

    const selectedVendorKeys = Array.from(new Set(
      this.selectedData.map((item: any) => this.getVendorKey(item)).filter(Boolean)
    ));

    if (selectedVendorKeys.length > 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select orders from the same vendor to create a bill.'
      });
      return;
    }

    if (!selectedVendorKeys.length) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Vendor details are missing for selected orders.'
      });
      return;
    }

    this.ref = this.dialogService.open(VendorBillPopupComponent, {
      header: '',
      data: {
        orders: this.selectedData
      },
      width: '70vw',
      contentStyle: { overflow: 'auto' },
      draggable: true,
      styleClass: 'no-close-icon-dialog vendor-bill-dialog',
    });

    this.ref.onClose.subscribe((payload: any) => {
      if (payload) {
        this.selectedData = [];
        this.selectedRows = [];
        this.getList();
      }
    });
  }

  createCustomerBill(): void {
    if (!this.selectedData?.length) {
      return;
    }

    const selectedVendorKeys = Array.from(new Set(
      this.selectedData.map((item: any) => this.getVendorKey(item)).filter(Boolean)
    ));

    if (selectedVendorKeys.length > 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select orders from the same customer to create a bill.'
      });
      return;
    }

    if (!selectedVendorKeys.length) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Customer details are missing for selected orders.'
      });
      return;
    }

    this.ref = this.dialogService.open(CustomerBillPopupComponent, {
      header: '',
      data: {
        orders: this.selectedData
      },
      width: '70vw',
      contentStyle: { overflow: 'auto' },
      draggable: true,
      styleClass: 'no-close-icon-dialog vendor-bill-dialog',
    });

    this.ref.onClose.subscribe((payload: any) => {
      if (payload) {
        this.selectedData = [];
        this.selectedRows = [];
        this.getList();
      }
    });
  }

  
  private getVendorKey(item: any): string {
    return String(item?.vendorId || item?.vendor?.id || item?.vendorName || '').trim();
  }


  viewOrderHistory(id: any) {
    if (this.notRole('ROLE_VENDOR')) {
      this.tabService.addTab({
        label: 'Orders View',
        path: 'orders/order-view/' + id,
        fullPath: '',
        filterData: [],
      });
      this.router.navigate(['orders/order-view/' + id]);
    }
  }

  createFtlOrder(type: any) {
    // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open( CreateTmsOrderComponent, {
      header: `${type} Order`,
      data: type == 'Add' ? {} : {
        editData: this.selectedData,
        edit: this.editContation
      },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
    });
  }

  receiveDataEvent(data: any[]) {
    console.log(data)
    this.selectedData = data
  }
  editEvent() {
    this.editContation = true
    console.log(this.editContation)
    this.createFtlOrder('Edit')
  }
  deleteEvent() {
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.emsServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent() {
    console.log(this.selectedData)
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
    };
    //  this.emsServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }


  upload(url: any, params: any) {
    this.tabService.addTab({
      label: 'Upload', path: url,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate([url], { queryParams: params })
  }

  onQuickFilter(filter: any): void {
    this.activeQuickFilter = filter.value;
    this.pageNumber = 0;
    this.getList();
  }

  
buildBiddingForm(): void {
  this.biddingForm = this.fb.group({
    bidAmount:       [null, [Validators.required, Validators.min(1)]],
    vehicleProvided: [1,    [Validators.required, Validators.min(1)]]
  });
}
 
openBiddingDialog(item: any): void {
  this.currentBiddingOrder = item;
  this.biddingForm.reset({
    bidAmount:       item?.bidAmount       || null,
    vehicleProvided: item?.numberOfVehicle || 1
  });
  this.showBiddingDialog = true;
}
 
closeBiddingDialog(): void {
  this.showBiddingDialog = false;
  this.biddingLoading = false;
}
 
isBiddingInvalid(field: string): boolean {
  const ctrl = this.biddingForm.get(field);
  return !!ctrl && ctrl.touched && ctrl.invalid;
}
 
onBiddingAction(status: any, selectedBiddingItem: any): void {

  if (status !== 'RejectedByVendor' && this.biddingForm.invalid) {
    this.biddingForm.markAllAsTouched();
    return;
  }

  const formValue = this.biddingForm.value;

  this.biddingLoading = true;

  this.getNextCounter(selectedBiddingItem?.id, (counter) => {

    const payload: any = {
      id:               selectedBiddingItem?.id,
      status:           status,
      finalAcceptance:  'VENDOR',
      counterNumber:          counter
    };

    if (status !== 'RejectedByVendor') {
      payload.bidAmount       = formValue.bidAmount;
      payload.vehicleProvided = formValue.vehicleProvided;
    }

    this.ordersService.createUpdateOrderBidding(payload).subscribe({
      next: (res: any) => {
        this.biddingLoading = false;
        this.showBiddingDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.responseMessage || 'Action completed successfully'
        });
        this.getList();
      },
      error: (err: any) => {
        this.biddingLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.responseMessage || 'Something went wrong'
        });
      }
    });
  });
}

openBiddingConfirmation(status: string, item?: any): void {
  this.pendingBiddingStatus = status;
  this.selectedBiddingItem = item || this.currentBiddingOrder;
  this.showBiddingConfirmDialog = true;
}

confirmBiddingAction(): void {
  if (!this.pendingBiddingStatus) {
    return;
  }

  this.showBiddingConfirmDialog = false;
  if(this.pendingBiddingStatus === 'AcceptedByVendor' || this.pendingBiddingStatus === 'RejectedByVendor'){
    this.biddingForm.controls['bidAmount'].setValue(this.selectedBiddingItem?.procurementPrice)
    this.biddingForm.controls['vehicleProvided'].setValue(this.selectedBiddingItem?.numberOfVehicles)
  }
  this.onBiddingAction(
    this.pendingBiddingStatus,
    this.selectedBiddingItem
  );

  this.pendingBiddingStatus = null;
  this.selectedBiddingItem = null;
}

cancelBiddingAction(): void {
  this.showBiddingConfirmDialog = false;
  this.pendingBiddingStatus = null;
}

openViewBidding(item: any): void {
  this.dialogService.open(ViewBiddingComponent, {
    header: `View Bidding — ${item.orderNumber}`,
    data: {
      order: item
    },
    width: '90vw',
    contentStyle: { overflow: 'auto' },
    draggable: false,
    styleClass: 'no-close-icon-dialog'
  });
}

checkTripStatus(item: any,status:any): boolean {
  return item?.orderStatus?.some(
    (el: any) =>
      el.statusType === 'TRIP_STATUS' &&
      el.status === status
  ) || false;
}
checkHardPod(item: any,status:any): boolean {
  return item?.orderStatus?.some(
    (el: any) =>
      el.statusType === 'HARD_POD_STATUS' &&
      el.status === status
  ) || false;
}
checkSoftPod(item: any, status: any): boolean {
  return item?.orderStatus?.some(
    (el: any) =>
      el.statusType === 'SOFT_POD_STATUS' &&
      el.status === status
  ) || false;
}

endTrip(item:any){
  this.tabService.addTab({
    label: 'End Trip',
    path: 'orders/end-trip/' + item?.id,
    fullPath: '',
    filterData: [],
  });
  this.router.navigate(['orders/end-trip/' + item?.id]);
}
startTrip(item: any) {
  const isPending = this.checkTripStatus(item, 'PENDING');

  if (isPending) {
    const payload = {
      orderId: item?.id,
      accountId: item?.accountId,
      customerId: item?.customerId,
      totalAmount: item?.confirmedAmount,
      status: 'TRIP_GENERATED',
      vendorId: item?.vendorId,
    };

    this.ordersService.tripGenration(payload)
      .subscribe({
        next: () => this.goToTripPage(item),
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.responseMessage || 'Failed to create trip'
          });
        }
      });
  } else {
    this.goToTripPage(item);
  }
}

private goToTripPage(item: any) {
  this.tabService.addTab({
    label: 'Order Trip',
    path: 'orders/order-trip/' + item?.id,
    fullPath: '',
    filterData: [],
  });
  this.router.navigate(['orders/order-trip/' + item?.id]);
}
getOrderStatusLabel(status: string): string {
  if (!status) {
    return '--';
  }

  const key = status.toUpperCase().replace(/-|\s/g, '_');

  if (ORDER_STATUS_MAP[key]) {
    return ORDER_STATUS_MAP[key].label;
  }

  // Fallback
  return this.formatStatus(status);
}
formatStatus(value: string): string {
  if (!value) return '';

  let formatted = value
    // Convert camelCase/PascalCase to space-separated words
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // Convert snake_case to spaces
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, c => c.toUpperCase());

  // Preserve abbreviations
  formatted = formatted
    .replace(/\bLhc\b/g, 'LHC')
    .replace(/\bPod\b/g, 'POD')
    .replace(/\bApi\b/g, 'API')
    .replace(/\bOtp\b/g, 'OTP')
    .replace(/\bGst\b/g, 'GST');

  return formatted;
}

getStatusClass(status: string): string {

  const value = (status || '').toUpperCase();

  if (
    value.includes('APPROVED') ||
    value.includes('RECEIVED') ||
    value.includes('COMPLETED') ||
    value.includes('PAID') ||
    value.includes('ENDED')
  ) {
    return 'status-success';
  }

  if (
    value.includes('PENDING') ||
    value.includes('GENERATED') ||
    value.includes('CREATED') ||
    value.includes('IN_PROGRESS') ||
    value.includes('STARTED')
  ) {
    return 'status-warning';
  }

  if (
    value.includes('REJECTED') ||
    value.includes('FAILED') ||
    value.includes('CANCELLED')
  ) {
    return 'status-danger';
  }

  return 'status-default';
}

getOrderStatusClass(status: string): string {

  const value = (status || '').toUpperCase();

  switch (value) {

    case 'QUOTE_PENDING_ON_KAM':
    case 'QUOTE_PENDING_ON_PROCUREMENT':
    case 'ORDER_PENDING':
    case 'QUOTE_PENDING':
    case 'PENDINGONVENDOR':
    case 'PENDINGONCUSTOMER':
      return 'order-warning';

    case 'ORDER_CONFIRMED':
    case 'HEAD_APPROVED':
    case 'ACCEPTEDBYCUSTOMER':
      return 'order-success';

    case 'ORDER_CANCELLED':
    case 'ORDER_REJECTED':
      return 'order-danger';

    case 'ORDER_COMPLETED':
    case 'CREATED':
      return 'order-primary';

    default:
      return 'order-default';
  }
}

openTranscation(item: any): void {
  this.selectedBidForHistory = item;
  this.historyTransactions = [];
  this.transactionLoading = true;
  this.showTransactionDialog = true;

  // Vendor screen asks for its own bids; everyone else (procurement/KAM/head) asks for the customer side
  const userTypeValue = this.hasRole('ROLE_VENDOR') ? 'VENDOR' : 'CUSTOMER';

  const filterData = [
    { key: 'ORDER_ID_IN', value: item?.id },
    { key: 'USER_TYPE', value: userTypeValue }
  ];

  this.ordersService.getBiddingTransactions(filterData, 0, 100000, 'id', 'ASC').subscribe({
    next: (res: any) => {
      this.transactionLoading = false;
      this.historyTransactions = res?.responseObject?.content || [];
    },
    error: () => {
      this.transactionLoading = false;
      this.historyTransactions = [];
    }
  });
}

closeTransactionDialog(): void {
  this.showTransactionDialog = false;
  this.selectedBidForHistory = null;
  this.historyTransactions = [];
}

private getNextCounter(orderId: any, callback: (counter: number) => void): void {
  const filterData = [{ key: 'ORDER_ID_IN', value: orderId }];

  this.ordersService.getBiddingTransactions(filterData, 0, 100000, 'id', 'DESC').subscribe({
    next: (res: any) => {
      const transactions = res?.responseObject?.content || [];
      const maxCounter = transactions.reduce(
        (max: number, t: any) => Math.max(max, t?.counter || 0),
        0
      );
      callback(maxCounter + 1);
    },
    error: () => callback(1)
  });
}

getSummaryStatus(orderStatus: any[]): any[] {
  if (!orderStatus) {
    return [];
  }

  const allowedStatuses = new Set<string>();
  this.roleNames.forEach(role => {
    (this.summaryStatusConfig[role] || []).forEach(s => allowedStatuses.add(s));
  });

  return orderStatus.filter(status => allowedStatuses.has(status.statusType));
}

isColumnVisible(key: string): boolean {
  return this.columnPreferenceService.isVisible(this.MODULE_NAME, key);
}

}
